let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l3NOh")).then(() => parcelRequire('96xO4'));